import EdiRelationPhotogalleryCardForm from 'sites/forms/EdiRelationPhotogalleryCardForm.vue';
import TaxonomySelector from '@/modules/taxonomy/selector/Selector.vue';
import relationConfig from '@/modules/relation/config';

// New relation card option for Textblock
import RelationCardWithClipping from '@/modules/relation/card/form/RelationCardWithClippingForm.vue';

relationConfig.textblockImageRelation = {
  cardComponent: RelationCardWithClipping,
  cardParams: {
    aspectRatios: ['16-9-aspect-ratio', '21-9-aspect-ratio'],
    types: ['image'],
  },
};

relationConfig.relationListingImages = {
  cardComponent: RelationCardWithClipping,
  cardParams: {
    aspectRatios: ['16-9-aspect-ratio'],
    types: ['image'],
  },
};

relationConfig.relationMultimedia.cardParams.types = [
  'image',
  'video',
  'videoembed',
];

// Configure photogallery relation component
relationConfig.relationPhotogallery.cardComponent = EdiRelationPhotogalleryCardForm;
// Configuramos solamente estos tipos para evitar petes en la búsqueda
relationConfig.relationMoreInfo.cardParams.types = [
  'article', 'external', 'file',
];
